import request from '../utils/request'

// 官网公司简介简要
function getCompanyProfile(data){

    return request({
        url : '/companyProfile/getCompanyProfile',
        method : 'post',
        data,
    });

}

export default {
    getCompanyProfile
}